import { SELECT_TAB} from '../actions/types'
const INITIAL_STATE = {
    tab:1,
};
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SELECT_TAB:
            return {
                tab:1
            };
        default:
            return state;
    }
};












